/* GreenGrowShop: selector de precio por volumen (1 / 2 / 3+) */
(function () {
  var fmt = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 });
  function money(cents) {
    return fmt.format(Math.round(cents / 100));
  }

  function track(name, detail) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, detail);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, detail));
    } catch (e) {}
  }
  window.ggsTrack = track;

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    var input = root.querySelector('.ggs-stepper__input');
    var radios = root.querySelectorAll('.ggs-vol__tier input[type="radio"]');
    var off2 = Number(root.dataset.off2) || 0;
    var off3 = Number(root.dataset.off3) || 0;
    var liters = Number(root.dataset.liters) || 0;
    // Durante una promoción (ej. Cyber Day) el precio por volumen no se suma: se ocultan los niveles
    // y se muestra el precio con el % de la promoción, que es el que se cobra.
    var pct = window.ggsPromo && window.ggsPromo.pct > 0 ? window.ggsPromo.pct : 0;
    if (pct) {
      off2 = 0;
      off3 = 0;
      input.value = 1;
    }

    if (root.dataset.available === 'false') {
      root.querySelectorAll('input, button').forEach(function (el) { el.disabled = true; });
    }

    function price() {
      return Number(root.dataset.price) || 0;
    }

    function unitFor(qty) {
      if (pct) return Math.round((price() * (100 - pct)) / 100);
      if (qty >= 3 && off3) return price() - off3;
      if (qty >= 2 && off2) return price() - off2;
      return price();
    }

    function qty() {
      var q = parseInt(input.value, 10);
      return isNaN(q) || q < 1 ? 1 : q;
    }

    function render() {
      var q = qty();
      var unit = unitFor(q);
      var full = price() * q;
      var total = unit * q;
      var save = full - total;

      root.querySelector('[data-total]').textContent = money(total);

      var saveEl = root.querySelector('[data-save]');
      if (saveEl) {
        saveEl.hidden = save <= 0;
        saveEl.textContent = save > 0 ? 'Ahorras ' + money(save) : '';
      }

      var msg = '';
      if (off2 || off3) {
        if (q === 1 && off2) msg = 'Agrega 1 más y paga ' + money(price() - off2) + ' c/u';
        else if (q === 2 && off3) msg = 'Agrega 1 más y desbloquea ' + money(price() - off3) + ' c/u';
        else if (q >= 4) msg = 'Mantienes el mejor precio';
      }
      var msgEl = root.querySelector('[data-msg]');
      if (msgEl) msgEl.textContent = msg;

      var perLiter = root.querySelector('[data-per-liter]');
      if (perLiter && liters) perLiter.textContent = money(unit / liters) + ' por litro';

      var tier = Math.min(q, 3);
      radios.forEach(function (r) {
        r.checked = Number(r.value) === tier;
        var t = Number(r.value);
        var u = root.querySelector('[data-tier-unit="' + t + '"]');
        if (u) u.textContent = money(unitFor(t));
        var tierSave = root.querySelector('[data-tier-save="' + t + '"]');
        if (tierSave) tierSave.textContent = 'Ahorras ' + money(price() - unitFor(t)) + ' c/u';
      });
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        var t = Number(r.value);
        if (t < 3 || qty() < 3) input.value = t;
        render();
        track('select_volume', { product_id: root.dataset.productId, product: root.dataset.productTitle, quantity: qty() });
      });
    });

    root.querySelectorAll('[data-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        input.value = Math.max(1, qty() + Number(btn.dataset.step));
        render();
      });
    });

    input.addEventListener('change', function () {
      input.value = qty();
      render();
    });
    input.addEventListener('input', render);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        var info = root.closest('product-info');
        if (!variant || !info || !document.body.contains(root)) return;
        if (event.data.sectionId && info.dataset.section && event.data.sectionId !== info.dataset.section) return;
        root.dataset.price = variant.price;
        // La cantidad se activa o desactiva según el stock de la variante elegida.
        root.dataset.available = String(!!variant.available);
        root.querySelectorAll('input, button').forEach(function (el) { el.disabled = !variant.available; });
        render();
      });
    }

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-ggs-vol]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-ggs-upsell]');
    if (el) track('cart_upsell', { product_id: el.dataset.ggsUpsell });
  });
})();

/* GreenGrowShop: compromiso de entrega (cuenta regresiva a la hora de corte, hora de Chile) */
(function () {
  var DAYS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

  function chileNow() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Santiago',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
    }).formatToParts(new Date());
    var get = function (t) {
      var p = parts.find(function (x) { return x.type === t; });
      return p ? p.value : '';
    };
    var map = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return { day: map[get('weekday')], hour: Number(get('hour')) % 24, minute: Number(get('minute')) };
  }

  function update(el) {
    var cutoff = Number(el.dataset.cutoff) || 14;
    var days = (el.dataset.days || '').split(',').map(function (d) { return Number(d.trim()); }).filter(function (d) { return !isNaN(d); });
    if (!days.length) return;
    var now = chileNow();
    var minutesLeft = cutoff * 60 - (now.hour * 60 + now.minute);
    var text;
    if (days.indexOf(now.day) !== -1 && minutesLeft > 0) {
      var h = Math.floor(minutesLeft / 60);
      var m = minutesLeft % 60;
      text = el.dataset.today.replace('[tiempo]', (h ? h + ' h ' : '') + m + ' min');
    } else {
      var next = now.day;
      for (var i = 1; i <= 7; i++) {
        next = (now.day + i) % 7;
        if (days.indexOf(next) !== -1) break;
      }
      var label = (next === (now.day + 1) % 7) ? 'mañana' : DAYS[next];
      text = el.dataset.next.replace('el [dia]', label === 'mañana' ? 'mañana' : 'el ' + label).replace('[dia]', label);
    }
    var target = el.querySelector('[data-delivery-text]');
    if (target && target.textContent !== text) target.textContent = text;
  }

  function run() {
    document.querySelectorAll('[data-ggs-delivery]').forEach(update);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  setInterval(run, 60000);
  document.addEventListener('shopify:section:load', run);
  // El carrito se vuelve a dibujar tras cada cambio: actualiza la promesa de entrega al instante.
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; run(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* GreenGrowShop: "Agregar tercer saco" en el carrito (actualiza la línea sin recargar) */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-ggs-set-line]');
  if (!btn) return;
  e.preventDefault();
  // El botón vive dentro del carrito que debe actualizarse (página /cart o carrito lateral).
  var items = btn.closest('cart-items, cart-drawer-items') || document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
  var line = Number(btn.dataset.ggsSetLine);
  var qty = Number(btn.dataset.ggsSetQty);
  if (items && typeof items.updateQuantity === 'function') {
    // cart.js compara la respuesta con el valor del campo de cantidad: se actualiza antes para no mostrar un error falso.
    var input = document.getElementById(items.tagName === 'CART-ITEMS' ? 'Quantity-' + line : 'Drawer-quantity-' + line);
    if (input) input.value = qty;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    items.updateQuantity(line, qty, 'updates[]');
  } else {
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty }),
    }).then(function () { window.location.reload(); });
  }
});

// Carrito: "Completa tu envío gratis" — agrega el producto sugerido y vuelve a dibujar el carrito.
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-ggs-ship-add]');
  if (!btn) return;
  e.preventDefault();
  var drawer = document.querySelector('cart-drawer');
  var id = Number(btn.dataset.ggsShipAdd);
  btn.disabled = true;
  btn.classList.add('is-loading');
  var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
  fetch(addUrl + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
  })
    .then(function (r) { return r.json(); })
    .then(function (res) {
      if (res.status || !res.sections) {
        var err = new Error(res.description || res.message || '');
        err.fromShop = true;
        throw err;
      }
      if (window.ggsTrack) window.ggsTrack('ship_upsell_add', { variant_id: id });
      if (drawer && drawer.renderContents) drawer.renderContents({ id: id, sections: res.sections });
      else location.reload();
    })
    .catch(function (err) {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      // Mensaje de Shopify (ej. sin stock o límite de cantidad) o error de conexión.
      var box = btn.closest('.ggs-ship-up__item');
      var msg = box && box.querySelector('.ggs-ship-up__error');
      if (box && !msg) {
        msg = document.createElement('span');
        msg.className = 'ggs-ship-up__error';
        msg.setAttribute('role', 'alert');
        box.querySelector('.ggs-ship-up__info').appendChild(msg);
      }
      if (msg) msg.textContent = err && err.fromShop && err.message ? err.message : 'No se pudo agregar. Intenta de nuevo.';
    });
});
